import api from '@/api';
import {
  AccountInstallmentPayableObservationRequest,
  AccountPayableObservation,
  AccountPayableObservationRequest,
  AccountPayableObservationUpdateRequest,
} from './AccountPayableObservation.types';

import { API_BASE_URL } from '..';
const baseUrl = `${API_BASE_URL}/AccountPayableObservation`;

export async function accountPayableObservationCreate(
  obj: AccountPayableObservationRequest,
) {
  const result = (await api.post(baseUrl, obj, null)) as unknown;

  return result as AccountPayableObservation;
}

export async function accountPayableObservationList(
  obj: AccountInstallmentPayableObservationRequest,
) {
  const result = (await api.get(baseUrl, obj)) as unknown;

  return result as AccountPayableObservation[];
}

export async function accountPayableObservationUpdate(
  obj: AccountPayableObservationUpdateRequest,
) {
  const result = (await api.put(baseUrl, obj, null)) as unknown;

  return result;
}

export async function accountPayableObservationDelete(id: number) {
  const result = (await api.remove(`${baseUrl}/${id}`, {}, null)) as unknown;

  return result;
}
